import IpRoutes from './IpRoutes';

export const IP_BASE_ROUTES = '/ipPlan';

export { IpRoutes };
